import {newSpecPage} from '@stencil/core/testing';
import {RadioGroup} from '../radio-group';
import {Radio} from '../../JoyRadio/radio';

it('renders a message if radio group is invalid', async () => {
    const page = await newSpecPage({
        components: [RadioGroup, Radio],
        html: `
            <joy-radio-group name="radio-group" invalid invalid-text="Please pick a value">
                <joy-radio value="first">First value</joy-radio>
                <joy-radio value="second">Second value</joy-radio>
            </joy-radio-group>
        `,
    });

    const error = page.body.querySelector('joy-radio-group joy-form-error');
    expect(error).not.toBeNull();
});

it('renders a radio group with vertical layout', async () => {
    const page = await newSpecPage({
        components: [RadioGroup, Radio],
        html: `
        <joy-radio-group direction="vertical" name="radio-group">
            <joy-radio value="first">First value</joy-radio>
            <joy-radio value="second">Second value</joy-radio>
        </joy-radio-group>
        `,
    });

    const error = page.body.querySelector('joy-radio-group .joy-radio-group-container.joy-radio-group-vertical');
    expect(error).not.toBeNull();
});
